import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
  selector: "app-introduction-image",
  templateUrl: "./introduction-image.component.html",
  styleUrls: ["./introduction-image.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IntroductionImageComponent {}
